import { gql } from 'apollo-angular';

const GET_PLAN_IMPACT_SELLER_SIO = gql`
  query GetPlanImpact(
    $rfpId: Long!
    $offerId: Long!
    $tierId: Long!
    $primaryCrosses: Boolean
  ) {
    planImpact(
      rfpId: $rfpId
      offerId: $offerId
      tierId: $tierId
      primaryCrosses: $primaryCrosses
    ) {
      offer {
        id
        name
        unorderedTiers
  			unorderedPricing
        seller {
          name
        }
      }
      selectedTier {
        id
        name
        description
        cpaId
        order
        allowedPartnerIds
        dollarMarketShare
        unitMarketShare
        absoluteDollars
        absoluteUnits
        spendLevelType
        tierType
        active
      }
      plannedSpendLevel
      planImpacts {
        member {
          name
          address {
            city
            state
          }
        }
        planId
        results {
          savingsAmount
          savingsPct
          conversionsCount {
            totalConversionsCount
          }
          numberOfIncumbents
          excludedPlannedSpend
          compliancePlannedSpend
        }
      }
    }
  }
`;

export default GET_PLAN_IMPACT_SELLER_SIO;
